import React from "react";
import {
  CameraProvider,
  ChatProvider,
  DragProvider,
  LocationProvider,
  MicrophoneProvider,
  PluginProvider,
  VehicleProvider,
  ViewProvider,
  WeatherProvider,
} from ".";
import {
  buttonTheme,
  cardTheme,
  colorsTheme,
  configTheme,
  fontSizesTheme,
  globalTheme,
  tagTheme,
  tooltipTheme,
} from "../theme";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { useAuth } from "../../hooks";

const pluginTheme = extendTheme({
  colors: colorsTheme,
  components: {
    Button: buttonTheme,
    Card: cardTheme,
    Tag: tagTheme,
    Tooltip: tooltipTheme,
    Progress: {
      baseStyle: {
        filledTrack: {
          bg: "white",
        }
      }
    }
  },
  config: configTheme,
  fontSizes: fontSizesTheme,
  styles: {
    global: globalTheme,
  },
});

/**
 * Renders the plugin providers
 * 
 * @param {Object} props The props of the component
 * @returns The plugin providers
 */
const PluginProviders = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <ChakraProvider theme={pluginTheme}>{children}</ChakraProvider>;
  }

  return (
    <ChakraProvider theme={pluginTheme}>
      <ViewProvider>
        <CameraProvider>
          <MicrophoneProvider>
            <VehicleProvider>
              <LocationProvider>
                <WeatherProvider>
                  <DragProvider>
                    <PluginProvider>
                      <ChatProvider>{children}</ChatProvider>
                    </PluginProvider>
                  </DragProvider>
                </WeatherProvider>
              </LocationProvider>
            </VehicleProvider>
          </MicrophoneProvider>
        </CameraProvider>
      </ViewProvider>
    </ChakraProvider>
  );
};

export default React.memo(PluginProviders);
